export const PROGRESS_COLOR = {
  bar: 'var(--brand-public-primary)',
  default: 'var(--control-main-primary-default)'
};
export const BACKGROUND_COLOR = 'var(--surface-main-default)';